let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("d38PD")).then(() => parcelRequire('bP8Kf'));